import { helpers } from 'vuelidate/lib/validators';

export default {
    allowedValuesByRegex() {
        return helpers.regex(
            'allowedValuesByRegex',
            /^[\w\-.]+$/
        );
    },
    greaterThanZeroOrValueIsEqualNull(value) {
        return value > 0 || value === null;
    }
};